/**
 * URLs de checkout directo de Stock Digital.
 * Apuntan directo al checkout, sin pasar por la página de la tienda.
 */
export const CHECKOUT_URLS = {
  hogarNatural:
    'https://www.stockdigital.shop/checkouts/cn/hWNCjQgpGydzE5midYhoeXOk/es-ar?_r=AQAB4thQc-J71A1-z5mh8m1gGCjCHr-D8iJHn4Md7DJPwYA',
  superPack:
    'https://www.stockdigital.shop/checkouts/cn/hWNCjQHMU9rVATNt550xnQyg/es-ar?_r=AQABZq_eFVVVzsUaqq90kJlDISy9ZoYTEtqpOsFjN6vy',
} as const
